import NestedForm from "stimulus-rails-nested-form";
import StimulusReflex from "stimulus_reflex";

export default class extends NestedForm {
  static targets = ["target", "template"];
  static values = {
    wrapperSelector: {
      type: String,
      default: ".nested-form-wrapper",
    },
  };
  connect() {
    super.connect();
    console.log("Do what you want here.");
    StimulusReflex.register(this); // ← enregistre stimulate sur ce controller
  }
  add(event) {
    event.preventDefault();
    let content = this.next_until_target(
      event.target,
      "template",
    ).children[0].innerHTML.replace(
      /NEW_RECORD/g,
      new Date().getTime().toString(),
    );
    this.next_until_target(event.target, "target").insertAdjacentHTML(
      "beforebegin",
      content,
    );
    this.initCheckbox();
  }
  add_(event) {
    event.preventDefault();
    let content = this.previous_until_target(
      event.target,
      "template",
    ).children[0].innerHTML.replace(
      /NEW_RECORD/g,
      new Date().getTime().toString(),
    );
    this.previous_until_target(event.target, "target").insertAdjacentHTML(
      "beforebegin",
      content,
    );
  }
  add_association(event) {
    event.preventDefault();
    let content = this.templateTarget.innerHTML.replace(
      /NEW_RECORD/g,
      new Date().getTime().toString(),
    );
    this.targetTarget.insertAdjacentHTML("beforebegin", content);
  }
  remove(event) {
    event.preventDefault();
    let wrapper = event.target.closest(this.wrapperSelectorValue);

    let hasReflexElement = wrapper.querySelector(
      '[data-reflex*="cra_mensuels#update_hm"]',
    );

    
   
    let qteInput = wrapper.querySelector("input[name*='[qte]']");
    if (qteInput && hasReflexElement) {
      qteInput.value = ""; // On vide la quantité saisi pour déclencher les calculs de totaux
    } 
    
    if (wrapper.dataset.newRecord === "true") {
      wrapper.remove();
      if (hasReflexElement) {
        this.stimulate("cra_mensuels#update_hm", event.currentTarget);
      }
    } else {
      wrapper.style.display = "none";
      let input = wrapper.querySelector("input[name*='_destroy']");
      if (input) {
        input.value = "1";
      }
      // Pour un record existant, on stimule aussi pour mettre à jour les totaux globaux
      // if (hasReflexElement) {
      //   this.stimulate("cra_mensuels#update_hm", event.currentTarget);
      // }
    }
  }
  next_until_target(element, className) {
    var next = element.closest("tr");
    do {
      next = next.nextElementSibling;
    } while (next.className != className);
    return next;
  }
  previous_until_target(element, className) {
    var previous = element.closest("tr");
    do {
      previous = previous.previousElementSibling;
    } while (previous.className != className);
    return previous;
  }

  initCheckbox() {
    console.log("Hello form initeCheckbox");

    /************************************
     *			Date Pickers			*
     ************************************/

    // Default
    $(".datepicker-default").datepicker();

    // Animations
    $(".datepicker-animation").datepicker();

    // ANimations dropdown change event
    $(".dp-animation").on("change", function () {
      $(".datepicker-animation").datepicker(
        "option",
        "showAnim",
        $(this).val(),
      );
    });

    // Dates in other months
    $(".dp-other-month").datepicker({
      showOtherMonths: true,
      selectOtherMonths: true,
    });

    // Display button bar
    $(".dp-button-bar").datepicker({
      showButtonPanel: true,
    });

    // Display button bar
    $(".dp-inline").datepicker();

    // Display Month & Year Menu
    $(".dp-month-year").datepicker({
      changeMonth: true,
      changeYear: true,
    });

    // Display Multiple Months
    $(".dp-multiple-months").datepicker({
      numberOfMonths: 3,
      showButtonPanel: true,
    });

    // Constrain Input
    $(".dp-constrain-input").datepicker({
      constrainInput: true,
    });

    // Year Range
    $(".dp-year-range").datepicker({
      yearRange: "2015:2016",
    });

    // Step Months
    $(".dp-step-months").datepicker({
      stepMonths: 3,
    });
    // Formate date
    $(".dp-format-date").datepicker();
    $(".date-formats").on("change", function () {
      $(".dp-format-date").datepicker("option", "dateFormat", $(this).val());
    });

    // Icon Trigger
    $(".dp-icon-trigger").datepicker({
      showOn: "button",
      buttonImage: "../../../app-assets/images/jqueryui/calendar.png",
      buttonImageOnly: true,
      buttonText: "Select date",
    });

    // Populate Alternate Field
    $(".dp-for-alternate").datepicker({
      altField: ".dp-alternate",
      altFormat: "DD, d MM, yy",
    });

    // Restrict Date Range
    $(".dp-date-range").datepicker({
      minDate: -20,
      maxDate: "+1M +10D",
    });

    // Show Week Of The Year
    $(".dp-week-year").datepicker({
      showWeek: true,
      firstDay: 1,
    });

    // Select Date Range
    var dateFormat = "mm/dd/yy",
      from = $(".dp-date-range-from")
        .datepicker({
          defaultDate: "+1w",
          changeMonth: true,
        })
        .on("change", function () {
          to.datepicker("option", "minDate", getDate(this));
        }),
      to = $(".dp-date-range-to")
        .datepicker({
          defaultDate: "+1w",
          changeMonth: true,
        })
        .on("change", function () {
          from.datepicker("option", "maxDate", getDate(this));
        });

    function getDate(element) {
      var date;
      try {
        date = $.datepicker.parseDate(dateFormat, element.value);
      } catch (error) {
        date = null;
      }

      return date;
    }

    // Apply Skin
    $(".ui-datepicker").wrap('<div class="dp-skin"/>');
  }
}
